import { useState, useEffect } from 'react';
import { getCurrentPokemonId, getPokemonImage } from './PokemonData';

const GiftBoxIcon = () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="14" height="14"><path strokeLinecap="round" strokeLinejoin="round" d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" /></svg>;
const PlusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" /></svg>;
const MinusIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path fillRule="evenodd" d="M3.75 12a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z" clipRule="evenodd" /></svg>;
const EditIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="12" height="12"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" /></svg>;
const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="12" height="12"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" /></svg>;

const SOUNDS = {
    up: new Audio('https://assets.mixkit.co/active_storage/sfx/2000/2000-preview.mp3'),
    down: new Audio('https://codeskulptor-demos.commondatastorage.googleapis.com/GalaxyInvaders/bonus.wav'),
    redeem: new Audio('https://assets.mixkit.co/active_storage/sfx/2017/2017-preview.mp3') 
};
SOUNDS.up.volume = 0.5; SOUNDS.down.volume = 0.5; SOUNDS.redeem.volume = 0.6;

const StudentCard = ({ student, isEditMode, onScoreChange, onAvatarClick, onDeleteStudent, onEditStudent, onBuyCard, onUseCard }) => {
    const [animate, setAnimate] = useState('');
    const [scoreMode, setScoreMode] = useState('default');

    useEffect(() => {
        if (animate) {
            const timer = setTimeout(() => setAnimate(''), 400);
            return () => clearTimeout(timer);
        }
    }, [animate]);

    const handleScoreClick = (delta) => {
        try {
            const audio = delta > 0 ? SOUNDS.up : SOUNDS.down;
            if (!audio.paused) audio.currentTime = 0;
            audio.play().catch(() => {});
        } catch (e) {}
        onScoreChange(student.id, student.score + delta);
        setAnimate(delta > 0 ? 'score-up-effect' : 'score-down-effect');
        setScoreMode('default');
    };

    const handleRedeem = () => {
        try { if (!SOUNDS.redeem.paused) SOUNDS.redeem.currentTime = 0; SOUNDS.redeem.play().catch(() => {}); } catch (e) {}
        onBuyCard(student);
        setAnimate('score-down-effect'); 
    };

    const getScoreColor = () => {
        if (student.score >= 20) return '#fbbf24'; 
        if (student.score >= 10) return '#38bdf8'; 
        return '#34d399'; 
    };

    const currentPokemonId = getCurrentPokemonId(student.avatarId, student.score);

    return (
        <div className={`ct-student-card ${animate}`} style={{ 
            position: 'relative', 
            background: 'rgba(15, 23, 42, 0.6)', 
            backdropFilter: 'blur(10px)', 
            border: isEditMode ? '1px dashed rgba(239, 68, 68, 0.5)' : '1px solid rgba(56, 189, 248, 0.2)', 
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5)',
            display: 'flex', flexDirection: 'column', height: '100%', padding: '6px'
        }}>
            
            {/* DÜZENLEME MODU AÇIKSA BUTONLAR GÖRÜNÜR */}
            {isEditMode && (
                <div style={{ position: 'absolute', top: '6px', left: '6px', display: 'flex', gap: '4px', zIndex: 10 }}>
                    <button 
                        onClick={() => onEditStudent(student.id, student.name)} 
                        style={{ background: 'rgba(30, 41, 59, 0.9)', border: '1px solid rgba(56,189,248,0.5)', borderRadius: '6px', cursor: 'pointer', padding: '4px', color: '#38bdf8' }}
                        title="İsmi Düzenle"
                    ><EditIcon /></button>
                    <button 
                        onClick={() => onDeleteStudent(student.id, student.name)} 
                        style={{ background: 'rgba(30, 41, 59, 0.9)', border: '1px solid rgba(239,68,68,0.5)', borderRadius: '6px', cursor: 'pointer', padding: '4px', color: '#ef4444' }}
                        title="Öğrenciyi Sil"
                    ><TrashIcon /></button>
                </div>
            )}

            <div className="ct-score-badge" style={{ backgroundColor: getScoreColor(), boxShadow: `0 0 10px ${getScoreColor()}`, color: '#0f172a', fontWeight: '900', width: '22px', height: '22px', fontSize: '0.85rem', position: 'absolute', top: '6px', right: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
                {student.score}
            </div>

            {/* ESNEK (RESPONSIVE) GEMİ ALANI */}
            <div className="ct-avatar-area" onClick={() => onAvatarClick(student)} style={{ flex: '1 1 0', minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '15px', marginBottom: '5px', cursor: 'pointer' }}>
                <img 
                    src={getPokemonImage(currentPokemonId)} 
                    alt={currentPokemonId} 
                    className="ct-avatar-img" 
                    style={{ filter: 'drop-shadow(0 5px 10px rgba(0,0,0,0.5))', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
                />
            </div>
            
            {/* İSİM VE ROL ALANI (KÜÇÜLTÜLDÜ) */}
            <div className="ct-name-area" style={{ flex: '0 0 auto', textAlign: 'center', marginBottom: '4px' }}>
                <h6 className="ct-student-name" title={student.name} style={{ color: '#e0f2fe', textShadow: '0 0 5px rgba(56,189,248,0.3)', margin: '0 0 2px 0', fontSize: '0.75rem', lineHeight: '1.2' }}>{student.name}</h6>
                <div style={{fontSize: '0.55rem', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px'}}>{currentPokemonId}</div>
            </div>

            {/* KARTLAR */}
            <div style={{ flex: '0 0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '3px', minHeight: '18px', marginBottom: '6px' }}>
                {(student.cards || []).map((card, idx) => (
                    <div 
                        key={idx} 
                        onClick={() => onUseCard(student, idx)}
                        title={`${card.name} - ${card.desc}`}
                        style={{ cursor: 'pointer', fontSize: '0.9rem', padding: '2px', background: 'rgba(30, 41, 59, 0.8)', border: '1px solid rgba(56,189,248,0.3)', borderRadius: '6px' }}
                    >
                        {card.icon}
                    </div>
                ))}
            </div>

            {/* BUTONLAR (KÜÇÜLTÜLDÜ VE DARALTILDI) */}
            <div className="ct-btn-area" style={{ flex: '0 0 auto', display: 'flex', gap: '4px' }}>
                {scoreMode === 'default' && (
                    <>
                        <button onClick={() => setScoreMode('minus')} style={{ flex: 1, padding: '4px 0', background: 'rgba(239, 68, 68, 0.1)', color: '#fca5a5', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '6px', cursor: 'pointer', display: 'flex', justifyContent: 'center' }}><MinusIcon /></button>
                        <button onClick={handleRedeem} style={{ flex: 1, padding: '4px 0', background: 'rgba(168, 85, 247, 0.1)', color: '#d8b4fe', border: '1px solid rgba(168, 85, 247, 0.3)', borderRadius: '6px', cursor: 'pointer', display: 'flex', justifyContent: 'center' }}><GiftBoxIcon /></button>
                        <button onClick={() => setScoreMode('plus')} style={{ flex: 1, padding: '4px 0', background: 'rgba(16, 185, 129, 0.1)', color: '#6ee7b7', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '6px', cursor: 'pointer', display: 'flex', justifyContent: 'center' }}><PlusIcon /></button>
                    </>
                )}
                
                {scoreMode === 'plus' && (
                    <div style={{ display: 'flex', width: '100%', gap: '2px' }}>
                        {[1, 2, 3].map(val => (
                            <button key={val} onClick={() => handleScoreClick(val)} style={{ flex: 1, padding: '4px 0', background: 'rgba(16, 185, 129, 0.15)', color: '#6ee7b7', border: '1px solid rgba(16, 185, 129, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.8rem' }}>+{val}</button>
                        ))}
                        <button onClick={() => setScoreMode('default')} style={{ flex: 0.8, padding: '4px 0', background: 'rgba(100, 116, 139, 0.2)', color: '#94a3b8', border: '1px solid rgba(100, 116, 139, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.7rem' }}>✕</button>
                    </div>
                )}

                {scoreMode === 'minus' && (
                    <div style={{ display: 'flex', width: '100%', gap: '2px' }}>
                        {[1, 2, 3].map(val => (
                            <button key={val} onClick={() => handleScoreClick(-val)} style={{ flex: 1, padding: '4px 0', background: 'rgba(239, 68, 68, 0.15)', color: '#fca5a5', border: '1px solid rgba(239, 68, 68, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.8rem' }}>-{val}</button>
                        ))}
                        <button onClick={() => setScoreMode('default')} style={{ flex: 0.8, padding: '4px 0', background: 'rgba(100, 116, 139, 0.2)', color: '#94a3b8', border: '1px solid rgba(100, 116, 139, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.7rem' }}>✕</button>
                    </div>
                )}
            </div>

        </div>
    );
};

export default StudentCard;